import http from "../axios/http-common";

class InterfacePRMRJ {
  getPRMRJbyRM(rm) {
    return http.getData(`/rm/${rm}/prmrj`);
  }
  
  getPRMRJbyReg(reg,dpjp) {
    return http.getDataParam(`/prmrj/register/${reg}`, {
      params: {
        dpjp_id: dpjp
      }
    });
  }

  savePRMRJ(
    reg, rm, param
  ) {
    return http.postData(`/prmrj`, {
      register_id: reg,
      pasien_rm: rm,
      tgl_periksa : param["tgl_periksa"],
      uraian_klinis: param["uraian_klinis"],
      diagnosa: param["diagnosa"],
      tindakan: param["tindakan"],
      dpjp_id: param["dpjp"].id
    });
  }

  editPRMRJ(
    id, reg, rm, param
  ) {
    return http.putData(`/prmrj/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      tgl_periksa : param["tgl_periksa"],
      uraian_klinis: param["uraian_klinis"],
      diagnosa: param["diagnosa"],
      tindakan: param["tindakan"],
      dpjp_id: param["dpjp"].id
    });
  }
}
export default new InterfacePRMRJ();
